import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { RowDividerActionsHandle as RowDividerActionsHandle$1, StyledInsertRowButtonWrapper, StyledInsertRowButton } from "./RowDividerActionsHandleStyles.js";
import { Icon } from "@flatfile/design-system";
import { useTranslation } from "react-i18next";
const RowDividerActionsHandle = forwardRef(({ onAddRow, style }, ref) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(RowDividerActionsHandle$1, { ref, style, children: /* @__PURE__ */ jsx(StyledInsertRowButtonWrapper, { children: /* @__PURE__ */ jsxs(
    StyledInsertRowButton,
    {
      onClick: onAddRow,
      onMouseDown: (e) => {
        e.stopPropagation();
      },
      onMouseUp: (e) => {
        e.stopPropagation();
      },
      onMouseEnter: (e) => {
        e.stopPropagation();
      },
      children: [
        /* @__PURE__ */ jsx(Icon, { name: "plus", size: 12 }),
        " ",
        t("sheet.table.indexRow.insertRow")
      ]
    }
  ) }) });
});
RowDividerActionsHandle.displayName = "RowDividerActionsHandle";
export {
  RowDividerActionsHandle as default
};
